import { HTMLAttributes } from 'react';

export default function Section({
  className = '',
  children,
  ...props
}: HTMLAttributes<HTMLDivElement>) {
  return (
    <div className={`p-[30px] ${className}`} {...props}>
      {children}
    </div>
  );
}
